import {
  EnumFunnelTrackingCookies,
  setCookieWithFallback,
} from '@core/tracking/funnelTracking'

/**
 *
 */
export function persistLastEngagedLivestreamId(encodedLivestreamId: string) {
  setCookieWithFallback(
    EnumFunnelTrackingCookies.FW_LAST_ENGAGED_LIVESTREAM_ID,
    encodedLivestreamId,
  )
}
